import React, {useState} from 'react';
import {Alert, Button, Form} from 'react-bootstrap';
import {getEaseeSite, getEaseeSites} from '../../../../../../../shared/services/firebase';
import {FormSkeleton} from '../../../../../../../shared/ui/LoadingSkeletons';
import {Dropdown} from '../../../../../../../shared/ui/Dropdown';

/**
 * Easee-specific integration: credential ping → site list → circuit list.
 *
 * @param {object} props
 * @param {object} props.formData — current EV charger form data
 * @param {function} props.setFormData — state setter for form data
 * @param {function} props.onChange — direct field change handler (for circuitId)
 */
const EaseeIntegration = ({formData, setFormData, onChange}) => {
  const [easeeSites, setEaseeSites] = useState([]);
  const [selectedEaseeSite, setSelectedEaseeSite] = useState('');
  const [easeeSite, setEaseeSite] = useState({});
  const [easeeAccessToken, setEaseeAccessToken] = useState('');
  const [easeeError, setEaseeError] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchSites = async () => {
    setLoading(true);
    setEaseeError('');
    const data = await getEaseeSites(formData?.credentials?.username, formData?.credentials?.password);
    if (data.sites) {
      setEaseeSites(data.sites);
      setEaseeAccessToken(data.accessToken);
    } else {
      setEaseeError(data.error);
      setEaseeSites([]);
      setEaseeAccessToken('');
    }
    setLoading(false);
  };

  const fetchSite = async (e) => {
    setLoading(true);
    setEaseeError('');
    const siteId = e.target.value;
    setSelectedEaseeSite(siteId);
    setFormData({...formData, siteId});
    const data = await getEaseeSite(siteId, easeeAccessToken);
    if (data.site) {
      setEaseeSite(data.site);
    } else {
      setEaseeError(data.error);
      setEaseeSite({});
    }
    setLoading(false);
  };

  if (loading) return <FormSkeleton fields={1}/>;

  return (
    <Form.Group>
      <Button
        onClick={fetchSites}
        disabled={!formData?.credentials?.username || !formData?.credentials?.password}
      >
        Ping Easee Installation
      </Button>
      {easeeError && <Alert variant="danger" className="mt-2">{easeeError}</Alert>}
      {easeeSites.length > 0 && (
        <div className="mt-2">
          <Dropdown
            name="siteId"
            options={easeeSites.map((site) => ({value: site.id, label: site.name}))}
            value={selectedEaseeSite}
            onChange={fetchSite}
            placeholder="Select"
            block
          />
        </div>
      )}
      {easeeSite?.circuits?.length > 0 && (
        <div className="mt-2">
          <Dropdown
            name="circuitId"
            options={easeeSite.circuits.map((circuit) => ({value: circuit.id, label: circuit.panelName}))}
            value={formData?.circuitId || ''}
            onChange={onChange}
            placeholder="Select"
            block
          />
        </div>
      )}
    </Form.Group>
  );
};

export default EaseeIntegration;

